import { Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useState } from "react";
import VentaInfo from "./VentaInfo";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setErrorMessage } from "../../../shared/helpers/functionalities";
import TransportistaCambioForm from "./TransportistaCambioForm";
import { API_VENTAS } from "../../../shared/services/ventas";
import { API_ENVIOS } from "../../../shared/services/envios";

export default function EditForm({ 
  venta,
  onActionDone
}) {
  const dispatch = useDispatch();
  const [tab, setTab] = useState(venta.plataforma_id !== 12 ? 'venta-info' : 'seguimiento-pedido');

  const handleChangeTab = (_e, tab) => setTab(tab);

  const handleEditVenta = async(data) => {
    dispatch({ type: 'loading/set', payload: true });
    const response = await API_VENTAS.updateVenta(data)
    .catch(function (error) {
        dispatch({type: 'loading/set', payload: false});
        toast.error(setErrorMessage(error.message))
    });

    if(response && response.success) {
      dispatch({ type: 'loading/set', payload: false });
      toast.success(response.message)
      onActionDone();
    }
  }

  const handleChangeTransportista = async(data) => {
    if (data.length === 0) return false;
    
    dispatch({ type: 'loading/set', payload: true });
    const updateResults = await Promise.all(
      data.map(async (seguimientoPedido) => {
        try {
          const response = await API_ENVIOS.updateEnvio(seguimientoPedido);
          if (response?.success) {
            toast.success(`Envio ${seguimientoPedido.codigo_transporte} actualizado correctamente!`);
            return true;
          } else {
            dispatch({type: 'loading/set', payload: false});
            toast.error(`ERROR: Envio ${seguimientoPedido.codigo_transporte} no se ha podido actualizar!`);
            return false;
          }
        } catch (error) {
          dispatch({type: 'loading/set', payload: false});
          toast.error(`ERROR: Envio ${seguimientoPedido.codigo_transporte} no se ha podido actualizar!`);
          return false;
        }
      })
    );

    if(updateResults.some(result => result === true)) {
      dispatch({ type: 'loading/set', payload: false });
      onActionDone();
    }
  }

  return (
    <div className="w-100">
      <TabContext value={tab}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChangeTab} aria-label="Venta">
            { (venta?.plataforma_id !== 12) &&
              <Tab label="Información de venta" value="venta-info" />
            }
            { ( 
                venta?.plataforma_id === 1 ||           // RECAMBIOVERDE
                venta?.plataforma_id === 4 ||           // EBAY
                venta?.plataforma_id === 6 ||           // ECOOPARTS
                venta?.plataforma_id === 12 ||          // VENTA PROPIA
                venta?.plataforma_id === 14 ||          // OPISTO
                venta?.plataforma_id === 19             // AURGI
              )
              ?
              <Tab label="Seguimiento del pedido" value="seguimiento-pedido" />
              : ''
            }
          </TabList>
        </Box>
        <TabPanel value="venta-info">
          <div className="d-flex align-items-center justify-content-center">
            <div className="col-12 col-md-6">
              <VentaInfo 
                venta={venta}
                onVentaInfo={handleEditVenta}
              />
            </div>
          </div>
        </TabPanel>
        <TabPanel value="seguimiento-pedido">
          <div className="d-flex align-items-center justify-content-center">
            <div className="col-12 col-md-8">
                <TransportistaCambioForm 
                  venta={venta}
                  onTransportistaChange={handleChangeTransportista}
                />
            </div>
          </div>
        </TabPanel>
      </TabContext>
    </div>
  );
}
